<template v-else>
  <b-card>
    <b-skeleton
      animation="wave"
      width="85%"
    />
    <b-skeleton
      animation="wave"
      width="55%"
    />
    <b-skeleton
      animation="wave"
      width="70%"
    />
  </b-card>
</template>

<script>
import { BCard, BSkeleton } from 'bootstrap-vue'

export default {
  components: {
    BSkeleton,
    BCard,
  },
}

</script>
